import get from 'lodash.get';

const defaultAvailablePlatformComponents = Object.freeze([]);

const getAvailablePlatformComponents = (rootState) =>
  get(
    rootState,
    'user.partnerData.properties.availablePlatformComponents',
    defaultAvailablePlatformComponents
  );

export default getAvailablePlatformComponents;
